/* equipo-atc-recommendations.js (Equipo tier-2)
   v7's add-to-cart banner cross-sell ("Complete your cart with these items...").
   When the ATC flyout is inserted (the theme's cart JS clones it from the
   data-templates markup on every add-to-cart), fetch Shopify's related-product
   recommendations for the just-added product via the Section Rendering API
   (sections/equipo-atc-recommendations.liquid) and inject them into the
   banner's [data-equipo-atc-recommendations] slot. Injected rimg lazy images
   are de-lazied (real URL already sits in src; srcset holds the placeholder). */
(function () {
  var cache = {};

  function delazy(scope) {
    Array.prototype.forEach.call(
      scope.querySelectorAll('img[data-rimg="lazy"]'),
      function (img) {
        img.removeAttribute('srcset'); // srcset holds the SVG placeholder; src is the real URL
        img.setAttribute('data-rimg', 'loaded'); // 'loaded' state hides the sibling canvas shimmer via native CSS
      }
    );
    // Colour swatches are background-image <div>s lazied via data-rimg-template (a separate
    // EQUIPO EDIT from the <img> lazy path above). The banner has no rimg JS, so without this
    // they fell back to their swatch background-color — the "black square" swatches. The
    // template is already a direct URL, so apply it straight to the background.
    Array.prototype.forEach.call(
      scope.querySelectorAll('.productitem--swatches-swatch-inner[data-rimg-template]'),
      function (el) {
        if (el.getAttribute('data-rimg') === 'loaded') return;
        var tmpl = el.getAttribute('data-rimg-template');
        if (tmpl && !/url\(/.test(el.style.backgroundImage || '')) {
          el.style.backgroundImage = "url('" + tmpl + "')";
        }
        el.setAttribute('data-rimg', 'loaded');
      }
    );
  }

  function fill(banner) {
    var slot = banner.querySelector('[data-equipo-atc-recommendations]');
    if (!slot || slot.getAttribute('data-eqar-loaded')) return;
    slot.setAttribute('data-eqar-loaded', '1');

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return;
        var pid = cart.items[0].product_id;

        if (cache[pid]) {
          slot.innerHTML = cache[pid];
          delazy(slot);
          return;
        }

        var base = (window.Theme && window.Theme.routes && window.Theme.routes.product_recommendations_url)
          || '/recommendations/products';
        return fetch(base + '?section_id=equipo-atc-recommendations&product_id=' + pid + '&limit=5&intent=related')
          .then(function (r) { return r.text(); })
          .then(function (text) {
            var tmp = document.createElement('div');
            tmp.innerHTML = text;
            var content = tmp.querySelector('[data-equipo-atc-recommendations]');
            if (content && content.innerHTML.trim().length) {
              cache[pid] = content.innerHTML;
              slot.innerHTML = content.innerHTML;
              delazy(slot);
            }
          });
      })
      .catch(function () { /* banner still works without recommendations */ });
  }

  /* Grid quick-ATC spinner: the theme's JS applies the `processing` class on the
     PDP add-to-cart but NOT on product-grid quick-ATC buttons (verified on the
     dev theme) — the buttons carry the spinner spans and CSS, nothing triggers
     them. Add the class on click; clear it when the ATC banner opens (add
     complete) or after a safety timeout. */
  function clearGridSpinners() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.productitem--action-atc.processing'),
      function (b) { b.classList.remove('processing'); }
    );
  }

  /* Strip ATC buttons: the theme's quickshop/ATC handlers bind per-section at
     page load, so they never attach to our injected cards — natively the click
     does nothing. Handle it ourselves (owner request: add, then go to the cart):
     - single-variant product → add via /cart/add.js → straight to /cart
     - multi-variant product → the shopper must pick colour/size, so go to the
       product page (an "add" without options would guess the variant). */
  function handleStripAtc(btn) {
    btn.classList.add('processing');
    var card = btn.closest('[data-product-item], .productgrid--item, .productitem') || btn.parentElement;
    var link = card && card.querySelector('a[href*="/products/"]');
    var href = link && link.getAttribute('href');
    var handle = href && (href.match(/\/products\/([^/?#]+)/) || [])[1];
    if (!handle) { window.location.href = '/cart'; return; }
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (p.variants && p.variants.length === 1) {
          return fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: p.variants[0].id, quantity: 1 })
          }).then(function () { window.location.href = '/cart'; });
        }
        window.location.href = href;
      })
      .catch(function () { window.location.href = href; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.productitem--action-atc');
    if (!btn) return;
    if (btn.closest('[data-equipo-atc-recommendations]')) {
      e.preventDefault();
      e.stopPropagation();
      handleStripAtc(btn);
      return;
    }
    btn.classList.add('processing');
    window.setTimeout(clearGridSpinners, 5000);
  }, true);

  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      Array.prototype.forEach.call(m.addedNodes, function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches('.atc-banner--container')) {
          clearGridSpinners();
          fill(n);
        } else if (n.querySelector) {
          var b = n.querySelector('.atc-banner--container');
          if (b) { clearGridSpinners(); fill(b); }
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  // Safety net if the theme ever reuses one flyout node instead of cloning:
  // refresh on the cart-count event the flyout dispatches when it opens.
  window.addEventListener('cartcount:update', function () {
    var banners = document.querySelectorAll('.atc-banner--container');
    Array.prototype.forEach.call(banners, function (banner) {
      if (banner.closest('[data-templates]')) return; // skip the hidden template copy
      var slot = banner.querySelector('[data-equipo-atc-recommendations]');
      if (slot) slot.removeAttribute('data-eqar-loaded');
      fill(banner);
    });
  });
})();
